import { safe } from 'firebase-safekey';

import teamIdForUid from './teamIdForUid';

// Copied from /api/src/utils/firebase. Proved too difficult to share this code
// becasue of Jest, Webpack, and ESLint.
export const teamPath = (teamId) => teamId && `/teams/${safe(teamId)}`;
export const channelsPath = (teamId) => (
  teamId && `${teamPath(teamId)}/channels`
);
export const teamMetaPath = (teamId) => (
  teamId && `${teamPath(teamId)}/meta`
);
export const teamSlackPath = (teamId) => (
  teamId && `${teamPath(teamId)}/slack`
);
const userPath = ({ teamId, userId }) => (
  teamId && userId && `${teamPath(teamId)}/users/${safe(userId)}`
);
export const userMetaPath = ({ teamId, userId }) => (
  teamId && userId && `${userPath({ teamId, userId })}/meta`
);
export const userSlackPath = ({ teamId, userId }) => (
  teamId && userId && `${userPath({ teamId, userId })}/slack`
);
export const channelPath = ({ teamId, channelId }) => (
  teamId && channelId && `${channelsPath(teamId)}/${safe(channelId)}`
);
export const statusesPath = ({ teamId, channelId }) => (
  teamId && channelId && `${teamPath(teamId)}/statuses/${safe(channelId)}`
);

export function userPathForUid(uid) {
  if (!uid) { return null; }
  return userMetaPath({ teamId: teamIdForUid(uid), userId: uid });
}



/** WEBPACK FOOTER **
 ** ./src/utils/firebasePaths.js
 **/